// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3MztM","title":"ClientReferral_title__1I6VO","itemText":"ClientReferral_itemText__1ULvq"};